import { forwardRef, createElement } from "react";
const NextLinkStub = forwardRef(({ children, ...props }, ref) => createElement("a", { ...props, ref }, children));
export default NextLinkStub;
